const validationRules = {
  required: (v) => (!!v) || "Este campo é obrigatório",

  fullNameFormat: (v) => {
    if (!v) return true;
    const parts = v.trim().split(/\s+/);
    return parts.length >= 2 || 'Informe o nome e sobrenome';
  },

  professionalRequired: (isEmployed) => {
    return (v) => {
      if (isEmployed) {
        return !!v || 'Este campo é obrigatório'
      }
      return true
    }
  },

  minLengthCPF(value) {
    return value.length >= 14 || 'CPF incompleto';
  },

  minLengthTelefone(value) {
    return value.length >= 14 || 'Telefone incompleto';
  },

  minLengthCelular(value) {
    return value.length >= 15 || 'Celular incompleto';
  },

  email: (v) =>
    (!v || /.+@.+\..+/.test(v)) || "E-mail inválido",

  minLength: (min) => (v) =>
    (!v || v.length >= min) || `Mínimo ${min} caracteres`,

  maxLength: (max) => (v) =>
    (!v || v.length <= max) || `Máximo ${max} caracteres`,

  onlyNumbers: (v) =>
    (!v || /^[0-9]*$/.test(v)) || "Apenas números permitidos",

  endDate: (startDate) => (endDate) =>
    (!startDate || !endDate || startDate <= endDate) || "A data inicial não pode ser maior que a final",

  semesterDate: (period) => (startDate, endDate) => {
    if (!startDate || !endDate) return true;

    const startMonth = startDate.getMonth();
    const endMonth = endDate.getMonth();

    if (period === 1) {
      return (startMonth < 6 && endMonth < 6) || "A data não faz parte do 1º semestre";
    } else {
      return (startMonth > 5 && endMonth > 5) || "A data não faz parte do 2º semestre";
    }
  }
};

export default {
  install(app) {
    app.config.globalProperties.$rules = validationRules;
  },
};